import { RequiredDocumentsHeadingEnum } from "./create-application-documentation-enums/create-application-documentation-enums";
export class CreateApplicationDocumentationConstants {
    static NO_DOCUMENT_REQUIRED_MESSAGE = "No documents are required for this application, however you can submit any additional documents.";
    static NO_REQUIRED_DOCUMENTS_FOUND_MESSAGE = "No required documents found in the lookups, please contact system admin";
    static UPLOAD_REQUIRED_DOC_LABEL = "Note: Upload the required documents for the application as listed below.";
    static APPLICATIONS_DOCUMENTS_LABEL = "My application documents";
    static UPLOAD_OPTIONAL_DOC_LABEL = "Note: Upload the optional documents for the application as listed below.";
    static OPTIONAL_DOCUMENTS_LABEL = "Optional documentation";
    static ADD_DOCUMENTS_BTN_LABEL = "Add document";
    static ADD_DOCUMENTS_DIALOG_TITLE = "Add documents";
    static EDIT_DOCUMENTS_DIALOG_TITLE = "Edit documents";
    static EDIT_DOCUMENTS_BTN_LABEL = "Edit document";
    static DELETE_DOCUMENTS_BTN_LABEL = "Delete document";
    static DELETE_DOCUMENTS_LABEL = "Delete documents";
    static ATTACHMENT_LABEL = "Attachment";
    static DOWNLOAD_LABEL = "Download";
    static ADDITIONAL_APPLICATION_TYPE_CONSTANTS = "Additional";
    static IS_DOCUMENT_REQUIRED = "yes";
    static DOCUMENT_FORM_CONTROL_NAME = "documentForm";
    static DOCUMENTS_FORM_CONTROL_NAME = "documents";
    static DATE_PIPE_FORMAT = "dd/MM/yyyy hh:mm";
    static DELETE_DIALOG_TITLE = "Delete document(s)";
    static COMPONENT_NAME = "create-application-documentation";
    static modalBodyOptions = {
        size: "xl",
        centered: true,
        backdrop: "static",
    };
    static REQUIRED_DOCUMENTS_HEADING_LOOKUP = new Map([
        [RequiredDocumentsHeadingEnum.type, "type"],
        [RequiredDocumentsHeadingEnum.name, "name"],
        [RequiredDocumentsHeadingEnum.dateUploaded, "dateUploaded"],
        [RequiredDocumentsHeadingEnum.fileName, "fileName"],
        [RequiredDocumentsHeadingEnum.source, "source"]
    ]);
}
